function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M85 0L0 85H170L85 0Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M605 0L520 85H690L605 0Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1121 0L1036 85H1206L1121 0Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M315 0L230 85H400L315 0Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M853 0L768 85H938L853 0Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M169.5 36.5L121 85H218L169.5 36.5Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M689.5 36.5L641 85H738L689.5 36.5Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1205.5 36.5L1157 85H1254L1205.5 36.5Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M399.5 48.5L363 85H436L399.5 48.5Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M937.5 36.5L889 85H986L937.5 36.5Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M454 31L400 85H508L454 31Z",
  fill: "#949494",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M986 61L962 85H1010L986 61Z",
  fill: "#949494",
  fillOpacity: 0.6
});

function SvgMountains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1254,
    height: 85,
    viewBox: "0 0 1254 85",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.68d30ccb.svg";
export { ForwardRef as ReactComponent };